import { DatepickerProvider } from './context/context';
import Datepicker from './Datepicker';

const DatePickerWrapper = (props) => (
  <DatepickerProvider>
    <Datepicker {...props} />
  </DatepickerProvider>
);

export default DatePickerWrapper;
